// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"L2-z","dimensionLabel":"M2-z","styleChooserControlWrapper":"N2-z","styleChooserControl":"O2-z","disabled":"P2-z","giftCard":"Q2-z","styleChooserText":"R2-z"};